<template>
  <LoaderCircle class="animate-spin" />
</template>

<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next'
</script>